
<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-003.png">
                    </div>
                    <div class="col-sm-2 bott"  style="margin-top: 3%;">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-003.png">
                    </div>
                    
                    <div class="col-sm-8">
                        <p style="line-height: 100%;margin-bottom: 5%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            RENACER DE LAS CENIZAS<br>
                            INCENDIO Y RECUPERACIÓN DE LA<br>
                            BIBLIOTECA NACIONAL DEL PERÚ<br>
                        </p>
                    </div>
                    <div class="col-sm-2" style="margin-top: 3%;">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-003.png">
                            <br>
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: -8%;" width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-003.png">
                            <br>
                    </div>
                    
                </div>

                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS300 text-center">
                        <img width="85%" src="/assets/images/micrositio/micrositio33/RENACER-000.png">
                        </p>
                    </div>
                    <div class="col-sm-12">
                        <p class="fontMS300 text-justify font-24">
                            <span class="fontMS500 font-26">U</span>NO DE LOS MÁS TRÁGICOS EPISODIOS PARA LA 
                            BNP, FUE EL DESOLADOR INCENDIO QUE DESTRUYÓ GRAN PARTE DE LA INSTITUCIÓN, INCLUYENDO 
                            SU EDIFICIO E INNUMERABLES COLECCIONES. PERO, COMO EL AVE FÉNIX DE ENTRE LAS 
                            CENIZAS, LA BIBLIOTECA VOLVIÓ A SURGIR CON UNA RENOVADA GESTIÓN.
                            
                        </p>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</div>


<div class="fondoCeleste">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <!--
                    <div class="col-sm-2 bott">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-003.png">
                    </div> -->
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio33/RENACER-LINEA-000.png">
                    </div>
                    <div class="col-sm-8">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS700 text-justify text-gris font-40">
                            LA BIBLIOTECA ANTES DE SER LA BNP
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio33/RENACER-LINEA-000.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio33/RENACER-LINEA-000.png">
                    </div>
                    
                </div>
                <div class="col-sm-11">
                    <p class="fontMS300 text-justify font-24">
                        <br>
                        <span class="fontMS500 font-26">L</span>a historia de la BNP se remonta al año 1568, 
                        cuando la orden jesuita fundó el Colegio Máximo de San Pablo. En 1767, los jesuitas 
                        son expulsados de las colonias españolas y, al año siguiente, la biblioteca de la Orden 
                        pasó a formar parte de la Universidad Nacional Mayor de San Marcos.
                        <br>
                            
                    </p>
                </div>
                <div class="col-sm-1"></div>

            <div class="row" >
                <div class="col-sm-4"></div>
                <div class="col-sm-4">
                    <br>
                    <a href="http://hdl.handle.net/20.500.14428/79594"
                    target="_blank" style="color: black;">
                    <img  width="100%" src="/assets/images/micrositio/micrositio33/RENACER-001.jpg">
                    
                    </a>
                    
                </div>
                <div class="col-sm-4"></div>
            </div>
            <div class="row mt-5" >
                <div class="col-sm-1"></div>
                <div class="col-sm-5">
                    <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-antes-y-despues-del-incendio-1943/8/"
                    target="_blank" style="color: black;">
                    <img  width="100%" src="/assets/images/micrositio/micrositio33/RENACER-002.png">
                    </a>
                </div>
                <div class="col-sm-5 text-right">
                    <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-antes-y-despues-del-incendio-1943/36/"
                    target="_blank" style="color: black;">
                    <img  width="100%" src="/assets/images/micrositio/micrositio33/RENACER-003.png">
                    </a>
                </div>
                <div class="col-sm-1"></div>
            </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzul">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    
                    <div class="col-sm-7 mt-2">
                        <img class="" width="100%"
                            src="/assets/images/micrositio/micrositio33/RENACER-LINEA-001.png">
                    </div>
                    <div class="col-sm-5">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-white  font-40">
                            LA BNP EN EL SIGLO XIX                         
                        </p>
                    </div>
                </div>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio33/RENACER-LINEA-001.png">
                </div>

                <div class="row">
                    
                    <div class="col-sm-12">
                        <p class="text-justify text-white fontMS100 font-24">
                            <br><br>
                            <span class="fontMS500 font-26">E</span>l 28 de agosto de 1821, a un mes de haber proclamado 
                            la independencia, el general don José de San Martín firmó el decreto de creación de la 
                            Biblioteca Nacional del Perú sobre el antiguo local jesuita. El 17 de setiembre de 1822, 
                            se inauguró la Biblioteca Nacional. 
                            <br>
                        </p>
                        <p class="text-justify text-white fontMS100 font-24">
                            
                            Inicialmente contó con 11.256 volúmenes procedentes de 
                            la antigua biblioteca de los jesuitas y de donaciones particulares. Durante el siglo XIX, 
                            la biblioteca sufrió grandes saqueos en el contexto de conflictos. Figuras como Ricardo Palma 
                            lograron reorganizar la institución.
                            <br>
                        </p>

                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-2 "></div>
                    <div class="col-sm-8 mt-5">
                        <img width="100%" src="/assets/images/micrositio/micrositio33/RENACER-004.png">
                    </div>
                    <div class="col-sm-2 "></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio33/RENACER-LINEA-002.png">
                    </div>
                    <div class="col-sm-8">
                        <p style="line-height: 100%;margin-bottom: 0%; color: #0a6da3;"
                            class="fontMS700 text-right font-45">
                            EL INCENDIO DE LA BIBLIOTECA<br>
                            NACIONAL DEL PERÚ
                        </p>

                        
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio33/RENACER-LINEA-002.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio33/RENACER-LINEA-002.png">
                    </div>
                    
                </div>

            <div class="row" >
                <div class="col-sm-2"></div>
                <div class="col-sm-8">
                    <br>
                    <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-antes-y-despues-del-incendio-1943/50/"
                    target="_blank" style="color: black;">
                    <img  width="100%" src="/assets/images/micrositio/micrositio33/RENACER-005.png">
                    </a>
                </div>
                <div class="col-sm-2"></div>
            </div>
            <div class="row mt-5" >
                <div class="col-sm-12">
                    <p class="text-justify text-gris fontMS300 font-24 " > 
                        <span class="text-gris fontMS500 font-26 " >
                            E</span>l incendio de la madrugada del 10 de mayo de 1943, dejó como saldo una gran sensación 
                            de desolación en el pueblo peruano, pues gran parte de las colecciones de la Biblioteca 
                            Nacional del Perú se habían perdido.  Por si fuera poco, en el mismo edificio se 
                            albergaban otras dos instituciones que también perdieron sus archivos: el Instituto 
                            Histórico y la Sociedad Geográfica. 
                        
                    </p>
                    <p class="text-justify text-gris fontMS300 font-24 " > 
                        <span>
                            Los bomberos lograron salvar al Archivo Nacional, la sección de revistas extranjeras y parte 
                            de la oficina del director de la biblioteca, donde se encontraban algunas obras invaluables. 
                            También lograron encajonar a las llamas para que no avanzaran hacia el resto de la manzana.
                        </span>
                    </p>
                </div>
            </div>
            <div class="row" >
                <div class="col-sm-4">
                    <br>
                    <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-antes-y-despues-del-incendio-1943/42/"
                    target="_blank" style="color: black;">
                    <img  width="100%" src="/assets/images/micrositio/micrositio33/RENACER-006.png">
                    </a>
                </div>
                <div class="col-sm-4">
                    <br>
                    <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-antes-y-despues-del-incendio-1943/38/"
                    target="_blank" style="color: black;">
                    <img  width="100%" src="/assets/images/micrositio/micrositio33/RENACER-007.png">
                    </a>
                </div>
                <div class="col-sm-4">
                    <br>
                    <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-antes-y-despues-del-incendio-1943/64/"
                    target="_blank" style="color: black;">
                    <img  width="100%" src="/assets/images/micrositio/micrositio33/RENACER-008.png">
                    </a>
                </div>
            </div>

            <div class="row mt-5" >
                <div class="col-sm-12">
                    <p class="text-justify text-gris fontMS300 font-24 " > 
                        <span class="text-gris fontMS500 font-26 " >
                            T</span>ras 9 horas de lucha, los bomberos cerraron sus mangueras, aunque algunas 
                            compañías se quedaron haciendo guardias por turno por si el fuego volvía a avivarse. 
                            Trabajadores de la biblioteca, bajo la guía del entonces director Carlos A. Romero, 
                            empezaron a buscar de entre los escombros y lodo, aquel material que habría sobrevivido 
                            a las llamas y al agua. Aunque lograron rescatar algunos ejemplares, otros quedaron en muy 
                            mal estado.
                        
                    </p>
                    <p class="text-justify text-gris fontMS300 font-24 " > 
                        <span>
                            Fue difícil saber la cifra exacta de lo perdido, pues no se tenía un catálogo completo de 
                            los fondos. Según su director, lo perdido sumaba más de 100,000 volúmenes empastados, 
                            4,000 sin empastar y unos 40,000 manuscritos, entre otras colecciones de publicaciones 
                            periódicas. 
                        </span>
                    </p>
                </div>
            </div>
            <div class="row" >
                <div class="col-sm-6">
                    <br>
                    <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-antes-y-despues-del-incendio-1943/44/"
                    target="_blank" style="color: black;">
                    <img  width="100%" src="/assets/images/micrositio/micrositio33/RENACER-009.png">
                    </a>
                </div>
                <div class="col-sm-6">
                    <br>
                    <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-antes-y-despues-del-incendio-1943/66/"
                    target="_blank" style="color: black;">
                    <img  width="100%" src="/assets/images/micrositio/micrositio33/RENACER-010.png">
                    </a>
                </div>
            </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGrisO ">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    
                    <div class="col-sm-12">
                        <p class="text-justify text-white fontMS300 font-24">
                            
                            <span class="fontMS500 font-26">P</span>rontamente, el gobierno creó una comisión para 
                            la investigación de las causas del suceso. Dentro de otras hipótesis, se consideró la 
                            ocurrencia de una posible falla eléctrica como detonante. 
                            <br>
                        </p>
                        <p class="text-justify text-white fontMS300 font-24">
                            Desde hacía años, la biblioteca sufría desperfectos y requerimientos que no lograban 
                            ser satisfechos. Pese a las solicitudes de sus directores, estos continuaban siendo 
                            rezagados por los presupuestos estatales.
                            <br>
                        </p>

                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6 mt-5">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-antes-y-despues-del-incendio-1943/62/"
                        target="_blank" style="color: black;">
                        <img width="100%" src="/assets/images/micrositio/micrositio33/RENACER-011.png">
                        </a>
                    </div>
                    <div class="col-sm-6 mt-5">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-antes-y-despues-del-incendio-1943/60/"
                        target="_blank" style="color: black;">
                        <img width="100%" src="/assets/images/micrositio/micrositio33/RENACER-012.png">
                        </a>
                    </div>
                    
                </div>
                <div class="row">
                    <div class="col-sm-12 mt-5">
                        <p class="text-white fontMS700 font-24" > 
                            Video: https://youtu.be/nQHaJSst5XY?si=xs5PWpU2BKO40B3M 
                        </p>
                        
                    </div>
                    <div class="col-sm-3 mt-2"></div>
                    <div class="col-sm-6 mt-2">
                        <a href="https://youtu.be/nQHaJSst5XY?si=xs5PWpU2BKO40B3M "
                        target="_blank" style="color: black;">
                        <img width="100%" src="/assets/images/micrositio/micrositio33/VIDEO.png">
                        </a>
                    </div>
                    <div class="col-sm-3 mt-2"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    
                    <div class="col-sm-7 mt-2">
                        <img class="" width="100%"
                            src="/assets/images/micrositio/micrositio33/RENACER-LINEA-000.png">
                    </div>
                    <div class="col-sm-5">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-gris font-40">
                            RENACER DESDE LAS CENIZAS                         
                        </p>
                    </div>
                </div>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio33/RENACER-LINEA-000.png">
                </div>

                <div class="row">
                    <div class="col-sm-2 "></div>
                    <div class="col-sm-8 mt-5">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-antes-y-despues-del-incendio-1943/46/"
                        target="_blank" style="color: black;">
                        <img width="100%" src="/assets/images/micrositio/micrositio33/RENACER-013.png">
                        </a>
                    </div>
                    <div class="col-sm-2 "></div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <p class="text-justify text-gris fontMS300 font-24">
                            <br><br>
                            <span class="fontMS500 font-26">P</span>ocos días después del siniestro, el presidente 
                            Manuel Prado Ugarteche emitió una resolución suprema para la organización de una comisión 
                            reconstructora, donde entre otros personajes se encontró Jorge Basadre, quien poco después 
                            sería nombrado como nuevo director de la BNP.
                            <br>
                        </p>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</div>

<div class="fondoCelesteO ">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-12">
                        <p class="text-justify text-white fontMS300 font-24">
                            <span class="fontMS500 font-26">D</span>entro de las primeras direcciones de la nueva 
                            gestión, se trató de salvar las colecciones que se pudo rescatar de entre las cenizas, 
                            agua y lodo, trasladando temporalmente estos materiales al área del Archivo Nacional, 
                            y posteriormente a la Escuela Nacional de Bellas Artes. 
                            <br>
                        </p>
                        <p class="text-justify text-white fontMS300 font-24">
                            La comisión para la reconstrucción de la BNP se compuso de subcomisiones con tareas 
                            como la de recolectar donativos económicos, realizar la compra de nuevas colecciones 
                            y libros, recibir los libros donados, y gestionar la catalogación de las colecciones.
                            <br>
                        </p>

                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6 mt-5">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-antes-y-despues-del-incendio-1943/56/"
                        target="_blank" style="color: black;">
                        <img width="100%" src="/assets/images/micrositio/micrositio33/RENACER-014.png">
                        </a>
                    </div>
                    <div class="col-sm-6 mt-5">
                        <a href="http://hdl.handle.net/20.500.14428/79595"
                        target="_blank" style="color: black;">
                        <img width="100%" src="/assets/images/micrositio/micrositio33/RENACER-015.png">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-12">
                        <p class="text-justify fontMS300 font-24">
                            <span class="fontMS500 font-26">A</span>simismo, se encargó de organizar la reconstrucción de 
                            la biblioteca, la cual por amplio consenso, se daría en la misma localización. El diseño de 
                            los planos estuvo a cargo del Ministerio de Fomento, encabezado por el arquitecto Emilio Harth 
                            Terré. En noviembre de 1943 se entregaron los planos, y en enero del año siguiente se realizó 
                            la ceremonia de colocación de la primera piedra.
                            <br>
                        </p>

                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-2 mt-5"></div>
                    <div class="col-sm-8 mt-5">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-construccion-del-nuevo-local-1943-1945/6/"
                        target="_blank" style="color: black;">
                        <img width="100%" src="/assets/images/micrositio/micrositio33/RENACER-016.png">
                        </a>
                    </div>
                    <div class="col-sm-2 mt-5"></div>
                </div>
                <div class="row">
                    <div class="col-sm-4 mt-5">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-construccion-del-nuevo-local-1943-1945/18/"
                        target="_blank" style="color: black;">
                        <img width="100%" src="/assets/images/micrositio/micrositio33/RENACER-017.png">
                        </a>
                    </div>
                    <div class="col-sm-4 mt-5">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-construccion-del-nuevo-local-1943-1945/24/"
                        target="_blank" style="color: black;">
                        <img width="100%" src="/assets/images/micrositio/micrositio33/RENACER-018.png">
                        </a>
                    </div>
                    <div class="col-sm-4 mt-5">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-construccion-del-nuevo-local-1943-1945/40/"
                        target="_blank" style="color: black;">
                        <img width="100%" src="/assets/images/micrositio/micrositio33/RENACER-019.png">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoVerdeO2">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-12">
                        <p class="text-justify fontMS300 text-white font-24">
                            <span class="fontMS500 font-26">L</span>a gestión de Basadre buscó renovar y tecnificar las 
                            labores bibliotecarias en el Perú, pues creía en la necesidad de una gestión moderna para una 
                            sociedad democrática. Por ello, a mediados de 1943 creó la Escuela Nacional de Bibliotecarios, 
                            desde donde promovió las prácticas de catalogación y clasificación de libros, cursos sobre 
                            organización y administración de bibliotecas, así como otros conocimientos y servicios de 
                            cara al público.
                            <br>
                        </p>
                        <p class="text-justify fontMS300 text-white font-24">
                            <span class="fontMS500 font-26">B</span>asadre también creó importantes publicaciones 
                            periódicas: el Boletín de la Biblioteca Nacional, sobre las actividades y operaciones de la 
                            biblioteca; la revista Fénix, especializada en bibliotecología; y el Anuario Bibliográfico, 
                            recuento anual de las publicaciones peruanas.
                            <br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-2 mt-5"></div>
                    <div class="col-sm-8 mt-5">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-construccion-del-nuevo-local-1943-1945/22/"
                        target="_blank" style="color: black;">
                        <img width="100%" src="/assets/images/micrositio/micrositio33/RENACER-020.png">
                        </a>
                    </div>
                    <div class="col-sm-2 mt-5"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-12">
                        <p class="text-justify fontMS300 font-24">
                            <span class="fontMS500 font-26">P</span>or fin, la Biblioteca Nacional del Perú logró reabrir 
                            sus puertas cuatro años después del fatal incendio. La nueva política bibliotecaria y mejorados 
                            servicios con una visión social sentaron las bases para recuperar y reimaginar a la institución.
                            <br>
                        </p>

                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-2 mt-5"></div>
                    <div class="col-sm-8 mt-5">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-construccion-del-nuevo-local-1943-1945/50/"
                        target="_blank" style="color: black;">
                        <img width="100%" src="/assets/images/micrositio/micrositio33/RENACER-021.png">
                        </a>
                    </div>
                    <div class="col-sm-2 mt-5"></div>
                </div>
                <div class="row">
                    <div class="col-sm-4 mt-5">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-construccion-del-nuevo-local-1943-1945/58/"
                        target="_blank" style="color: black;">
                        <img width="100%" src="/assets/images/micrositio/micrositio33/RENACER-022.png">
                        </a>
                    </div>
                    <div class="col-sm-4 mt-5">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-construccion-del-nuevo-local-1943-1945/64/"
                        target="_blank" style="color: black;">
                        <img width="100%" src="/assets/images/micrositio/micrositio33/RENACER-023.png">
                        </a>
                    </div>
                    <div class="col-sm-4 mt-5">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-biblioteca-nacional-construccion-del-nuevo-local-1943-1945/54/"
                        target="_blank" style="color: black;">
                        <img width="100%" src="/assets/images/micrositio/micrositio33/RENACER-024.png">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>




<div class="fondoVerde">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-1">
                        <img src="\assets\images\micrositio\micrositio27\ALBUMES-025.png" >
                    </div>
                    <div class="col-sm-2"></div>
                    <div class="col-sm-5">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS300Italic text-white font-26 text-right">
                            <br><br><br><br>
                            PREGUNTAS PARA REFLEXIONAR
                        </p>
                        <img width="100%" src="\assets\images\micrositio\micrositio33\RENACER-DIALOGO-000.png" >
                    </div>
                </div>
                <div class="row">
                    <div class="col-1 " style="width: 2%">
                        <p class="text-white text-justify font-24">
                        1. <br>
                    </p>
                    </div>
                    <div class="col-sm-11">
                        <p class="text-white text-justify font-24">
                            ¿Estás de acuerdo con la siguiente afirmación de Jorge Basadre: «Los culpables verdaderos por el olvido, en delito por omisión, eran el Estado, a través de muchos años 
                            y de varios gobiernos; y era también la opinión pública»? ¿Por qué?
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-1 " style="width: 2%">
                        <p class="text-white text-justify font-24">
                        2. <br>
                    </p>
                    </div>
                    <div class="col-sm-11">
                        <p class="text-white text-justify font-24">
                            ¿Quiénes participaron en el proceso de reconstrucción de la Biblioteca Nacional del 
                            Perú?
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-1 " style="width: 2%">
                        <p class="text-white text-justify font-24">
                        3. <br>
                    </p>
                    </div>
                    <div class="col-sm-11">
                        <p class="text-white text-justify font-24">
                            ¿Qué acciones deben tomarse para gestionar los riesgos de desastres en la Biblioteca 
                            Nacional del Perú?
                        </p>
                        <img width="50%" src="\assets\images\micrositio\micrositio33\RENACER-DIALOGO-000.png" >
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <img width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-001.png">
                    <br><br>
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center font-40" style="color: #465a65">
                            PARA SABER MÁS
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <p class="fontMS500 font-24" style="color: #465a65">
                            
                            BIBLIOGRAFÍA
                            <br><br>
                        </p>                        
                        <div class="row" style="color: #465a65">
                            <div class="col-sm-1" style="width: 7%">
                                <img src="/assets/images/micrositio/micrositio27/ALBUMES-026.png">
                            </div>
                            <div class="col-sm-11">
                                <p class="fontMS500 font-24">
                                Aguirre, Carlos. "Una tragedia cultural: el incendio de la Biblioteca Nacional del Perú", 
                                en Revista de la Biblioteca Nacional de Uruguay: La Biblioteca, N° 11-12, 2016. 
                                Pág. 107-139. 
                            </p>
                            </div>
                            <div class="col-sm-1" style="width: 7%">
                                <img src="/assets/images/micrositio/micrositio27/ALBUMES-026.png">
                            </div>
                            <div class="col-sm-11">
                                <p class="fontMS500 font-24 " style="word-wrap: break-word;">
                                Basadre, Jorge. "La Biblioteca Nacional de Lima (1943-1945)", en Fénix: 
                                revista de la Biblioteca Nacional del Perú. N° 2, enero-junio 1945. Pág. 312-352.
                            </p>
                            </div>
                            <div class="col-sm-1" style="width: 7%">
                                <img src="/assets/images/micrositio/micrositio27/ALBUMES-026.png">
                            </div>
                            <div class="col-sm-11">
                                <p class="fontMS500 font-24" style="word-wrap: break-word;">
                                Blass, Benjamín. "El incendio de la Biblioteca Nacional del Perú.
                                Aportes documentales", en Fénix: revista de la Biblioteca Nacional del Perú. 
                                N° 46, 2017. Pág. 15-38.  
                            </p>
                            </div>
                        </div>    
                    </div>
                    <div class="col-sm-1"></div>
            
            <div class="row">
                <div class="col-sm-12">
                    <img  width="100%"
                        src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-001.png">
                </div>
            </div>
    </div>
</div>